import { Directive, input, InputSignal } from '@angular/core';

@Directive({
  selector: '[appDisplayMode]',
  host: {
    class: 'display-mode',
    '[class.is-card]': 'isCard()',
  },
})
export class DisplayModeDirective {
  readonly isCard: InputSignal<boolean> = input<boolean>(false);
}
